import PropTypes from 'prop-types'
import {Box, VStack} from '@chakra-ui/react'
import {
  EmptyListContainer,
  EmptyListHeaderTag,
} from '~/react/components/EmptyList'

const EmptyState = ({title, description}) => {
  return (
    <EmptyListContainer px="none">
      <VStack spacing={6} maxW="md" textAlign="center">
        <EmptyListHeaderTag text={title} />
        <Box textStyle="body-copy" color="gray.600">
          {description}
        </Box>
      </VStack>
    </EmptyListContainer>
  )
}

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default EmptyState
